import React from 'react';
import AddTemplates from './AddTemplates';
import './WritePage.css';

// Standalone page for managing templates (previously accessed via mode switch on WritePage)
function TemplatesPage() {
  return (
    <>
      <div className="page write-page-content">
        <h1 className="write-page-heading">Templates</h1>
        <AddTemplates />
      </div>
    </>
  );
}

export default TemplatesPage;
